module.exports = __webpack_public_path__ + "img/3.47cf4c4d.jpg";